/**
 * TaskStatus — робочі статуси завдання (SPEC-004 §3, 5 case, без псевдо-`removed`).
 *
 * Реалізовано як string-union type + `STATUS_MAP` (а не TS `enum`) — це чинна
 * конвенція цього репозиторію: еталон autostrada `Ship/Contracts/Statuses/RequestStatus.ts`
 * має саме такий вигляд, а базовий eslint-rule `no-unused-vars` дає хибні помилки на
 * членах TS-enum. Набір значень і семантика ідентичні enum зі SPEC-008 §7.1.
 *
 * `STATUS_MAP` — єдине джерело істини «статус → підпис + колір»: використовується
 * полем `status` (`type: 'status'`), тегом у таблиці/картці, стрічкою історії та
 * вузлом дерева. Кольори — бренд-нейтральні hex (SPEC-008 §7.1); antd `Tag`
 * приймає як hex, так і preset-назви.
 */
export type TaskStatus = 'new' | 'in_process' | 'suspended' | 'overdue' | 'completed'

export interface TaskStatusInfo {
    label: string
    color: string
}

export const STATUS_MAP: Record<TaskStatus, TaskStatusInfo> = {
    new: { label: 'Нове', color: '#4A90E2' }, // синій
    in_process: { label: 'В роботі', color: '#50C878' }, // зелений
    suspended: { label: 'Призупинене', color: '#FAAD14' }, // бурштин
    overdue: { label: 'Прострочене', color: '#D96857' }, // червоний
    completed: { label: 'Завершене', color: '#8C8C8C' }, // сірий
}

export interface TaskStatusOption {
    value: string
    label: string
    color: string
}

/**
 * Похідне від `STATUS_MAP` — для `options` поля `status` (`type: 'status'`),
 * яке очікує кортежі `{ value, label, color }`.
 */
export const TASK_STATUS_OPTIONS: TaskStatusOption[] = (
    Object.entries(STATUS_MAP) as Array<[TaskStatus, TaskStatusInfo]>
).map(([value, info]) => ({ value, label: info.label, color: info.color }))
